var _desc, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumberIcoWhite(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "65px",
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trend") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final-screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Affiliate-quarter-dashboard1",
    transform: "translate(-1073.000000, -608.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(280.000000, 517.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(612.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trend",
    transform: "translate(181.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.0644531,22.8515625 L49.6386719,22.8515625 L49.6386719,61.1914062 L45.8300781,61.1914062 L45.8300781,38.0859375 L34.4042969,38.0859375 L34.4042969,61.1914062 L30.5957031,61.1914062 L30.5957031,30.46875 L19.1699219,30.46875 L19.1699219,61.1914062 L15.3613281,61.1914062 L15.3613281,41.8945312 L3.93554688,41.8945312 L3.93554688,61.1914062 L0,61.1914062 L0,65 L65,65 L65,61.1914062 L61.0644531,61.1914062 L61.0644531,22.8515625 Z M53.4472656,26.6601562 L57.2558594,26.6601562 L57.2558594,61.1914062 L53.4472656,61.1914062 L53.4472656,26.6601562 Z M38.2128906,41.8945312 L42.0214844,41.8945312 L42.0214844,61.1914062 L38.2128906,61.1914062 L38.2128906,41.8945312 Z M22.9785156,34.2773438 L26.7871094,34.2773438 L26.7871094,61.1914062 L22.9785156,61.1914062 L22.9785156,34.2773438 Z M7.74414062,45.703125 L11.5527344,45.703125 L11.5527344,61.1914062 L7.74414062,61.1914062 L7.74414062,45.703125 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "49.6386719 3.80859375 58.4803223 3.80859375 40.1208691 22.0664844 24.8864941 6.83210938 0.561513672 31.0227734 3.24708008 33.7233203 24.8791309 12.2108594 40.1135059 27.4452344 61.1914062 6.48375 61.1914062 15.234375 65 15.234375 65 2.84217094e-14 49.6386719 2.84217094e-14"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberIcoWhite);
export default __webpack_public_path__ + "static/media/number-ico-white.46928a0229e5eff22dc26da749ad34f8.svg";
export { ForwardRef as ReactComponent };